import { HTTP_STATUS_CODES, ROUTES } from "../constants/api";
import {
  HandleNewErrorResponse,
  HandleNewResponse,
} from "./handlers";
import { deleteMethod, get, post, put } from "./api";

/**
 * Class for static methods handling a user's bank accounts.
 */
class BankAccountsApi {
  /**
   * Deletes a bank account.
   * @constructor
   */
  static async DeleteBankAccount(allocationId: number) {
    let url = ROUTES.BANK_ACCOUNTS.DELETE_BANK_ACCOUNT(allocationId);

    try {
      let response = await deleteMethod(url);
      return HandleNewResponse(response);
    } catch (err) {
      return HandleNewErrorResponse(err);
    }
  }

  /**
   * Gets a bank account disbursement history
   * @constructor
   */
  static async GetDisbursementHistory(allocationId: number) {
    let url = ROUTES.BANK_ACCOUNTS.GET_DISBURSEMENT_HISTORY(allocationId);

    try {
      let response = await get(url);
      return HandleNewResponse(response);
    } catch (err) {
      return HandleNewErrorResponse(err);
    }
  }

  /**
   * Gets a list of countries and their currencies available for new bank accounts given user guid.
   * @constructor
   */
  static async GetCountriesCurrencies(userGuid: string) {
    let url = ROUTES.BANK_ACCOUNTS.GET_COUNTRIES_CURRENCIES(userGuid);

    try {
      let response = await get(url);
      return HandleNewResponse(response);
    } catch (err) {
      return HandleNewErrorResponse(err);
    }
  }

  /**
   * Gets fields for beneficiary bank details.
   * @constructor
   */
  static async GetBeneficiaryBankFields(countryId: number, currencyId: number, allocationId?: string) {
    let url: string;
    if (allocationId) {
      url = ROUTES.BANK_ACCOUNTS.GET_EDIT_BENEFICIARY_BANK_FIELDS(countryId, currencyId, allocationId);
    } else {
      url = ROUTES.BANK_ACCOUNTS.GET_BENEFICIARY_BANK_FIELDS(countryId, currencyId);
    }

    try {
      let response = await get(url);
      return HandleNewResponse(response);
    } catch (err) {
      return HandleNewErrorResponse(err);
    }
  }

  /**
   * Creates a new bank account.
   * @constructor
   */
  static async CreateBankAccount(requestBody: { fields: { [key: string]: string }[] }) {
    let url = ROUTES.BANK_ACCOUNTS.CREATE_BANK_ACCOUNT;

    try {
      let response = await post(url, requestBody);
      // Error response status was changed from 400 to 226
      // If status 226 is returned, we have validation errors
      if (response.status === HTTP_STATUS_CODES.VALIDATION_ERROR) {
        throw response;
      } else {
        return HandleNewResponse(response);
      }
    } catch (err) {
      return HandleNewErrorResponse(err);
    }
  }

  /**
   * Update a bank account.
   */
  static async UpdateBankAccount(requestBody: { fields: { [key: string]: string }[] }, allocationId: number) {
    let url = ROUTES.BANK_ACCOUNTS.UPDATE_BANK_ACCOUNT(allocationId);

    try {
      let response = await put(url, requestBody);
      // Error response status was changed from 400 to 226
      // If status 226 is returned, we have validation errors
      if (response.status === HTTP_STATUS_CODES.VALIDATION_ERROR) {
        throw response;
      } else {
        return HandleNewResponse(response);
      }
    } catch (err) {
      return HandleNewErrorResponse(err);
    }
  }

}

export default BankAccountsApi;
